export default __webpack_public_path__ + "static/takada-af946b69a72356de062660a2f7c780f8.png";